import { useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { useAuth } from "../context/AuthContext";

function downloadDataUrl(dataUrl, filename) {
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

function fmtWallet(n) {
  return "₹" + Number(n || 0).toLocaleString("en-IN");
}

function KycModal({ agent, onClose }) {
  return (
    <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(10,22,40,0.55)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:16,maxWidth:480,width:"100%",maxHeight:"90vh",overflowY:"auto",padding:28,position:"relative"}}>
        <button onClick={onClose} style={{position:"absolute",top:16,right:16,background:"#f6f8fc",border:"none",borderRadius:8,width:30,height:30,fontSize:15,cursor:"pointer",color:"#6b7a90"}}>✕</button>
        <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:22,fontWeight:700,color:"#0d1f3c",marginBottom:2}}>{agent.name}</h2>
        <p style={{fontSize:12,color:"#6b7a90",marginBottom:18}}>{agent.agency} · {agent.email}</p>

        <div style={{background:"#f6f8fc",borderRadius:10,padding:"12px 15px",marginBottom:14}}>
          <div style={{fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"#8a9bb5",fontWeight:600}}>PAN Number</div>
          <div style={{fontSize:14,color:"#1a2540",fontWeight:600,marginTop:3}}>{agent.pan_number || "—"}</div>
        </div>
        {agent.pan_card && (
          <div style={{marginBottom:18,textAlign:"center"}}>
            <img src={agent.pan_card} alt="PAN Card" style={{width:160,height:160,objectFit:"cover",borderRadius:12,border:"1px solid #e4e9f0"}}/>
            <div style={{marginTop:8}}>
              <button onClick={()=>downloadDataUrl(agent.pan_card, agent.pan_card_name||"pan-card.jpg")} style={{padding:"6px 14px",borderRadius:8,fontSize:11,fontWeight:600,background:"#e0ecff",color:"#2563eb",border:"none",cursor:"pointer"}}>⬇ Download PAN Card</button>
            </div>
          </div>
        )}

        <div style={{background:"#f6f8fc",borderRadius:10,padding:"12px 15px",marginBottom:14}}>
          <div style={{fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"#8a9bb5",fontWeight:600}}>Aadhar Number</div>
          <div style={{fontSize:14,color:"#1a2540",fontWeight:600,marginTop:3}}>{agent.aadhar_number || "—"}</div>
        </div>
        {agent.aadhar_card && (
          <div style={{textAlign:"center"}}>
            <img src={agent.aadhar_card} alt="Aadhar Card" style={{width:160,height:160,objectFit:"cover",borderRadius:12,border:"1px solid #e4e9f0"}}/>
            <div style={{marginTop:8}}>
              <button onClick={()=>downloadDataUrl(agent.aadhar_card, agent.aadhar_card_name||"aadhar-card.jpg")} style={{padding:"6px 14px",borderRadius:8,fontSize:11,fontWeight:600,background:"#e0ecff",color:"#2563eb",border:"none",cursor:"pointer"}}>⬇ Download Aadhar Card</button>
            </div>
          </div>
        )}

        {!agent.pan_number && !agent.aadhar_number && (
          <div style={{textAlign:"center",padding:"20px 0",color:"#8a9bb5",fontSize:13}}>This agent was added manually by admin — no KYC documents on file.</div>
        )}
      </div>
    </div>
  );
}

const STATUS_BADGE = {
  pending:  { label:"⏳ Pending",  bg:"#fef3e2", c:"#d97706" },
  active:   { label:"✅ Active",   bg:"#dcfce7", c:"#16a34a" },
  rejected: { label:"❌ Rejected", bg:"#fee2e2", c:"#dc2626" },
};

export default function AdminAgents({ navigate }) {
  const { getAgents, addAgent, approveAgent, rejectAgent, deleteAgent, setWallet, zeroWallet, users } = useAuth();
  const [form, setForm] = useState({name:"",email:"",agency:"",password:"",role:"agent"});
  const [msg,  setMsg]  = useState(null);
  const [busy, setBusy] = useState(null); // email currently being acted on, disables its buttons
  const [kycAgent, setKycAgent] = useState(null);
  const agents = getAgents();
  const s = k => e => setForm(p=>({...p,[k]:e.target.value}));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name||!form.email||!form.agency||!form.password) return setMsg({type:"err",text:"All fields are required."});
    try {
      await addAgent(form.email, form.name, form.agency, form.password, form.role);
      setMsg({type:"ok",text:`Agent ${form.name} added successfully.`});
      setForm({name:"",email:"",agency:"",password:"",role:"agent"});
    } catch (err) {
      setMsg({type:"err",text:err.message});
    }
  };

  const handleApprove = async (ag) => {
    const raw = window.prompt(`How much has ${ag.name} paid so far? (₹ — shown in their wallet as proof of payment. Leave blank for 0.)`, "");
    if (raw === null) return; // cancelled
    const amount = Math.max(0, Number(raw) || 0);
    setBusy(ag.email);
    try { await approveAgent(ag.email, amount); }
    catch (err) { setMsg({type:"err",text:err.message}); }
    setBusy(null);
  };

  const handleReject = async (ag) => {
    const reason = window.prompt(`Reason for rejecting ${ag.name}'s registration (optional):`, "");
    if (reason === null) return; // cancelled
    setBusy(ag.email);
    try { await rejectAgent(ag.email, reason); }
    catch (err) { setMsg({type:"err",text:err.message}); }
    setBusy(null);
  };

  const handleDelete = async (ag) => {
    if (!window.confirm(`Delete ${ag.name}?`)) return;
    setBusy(ag.email);
    try { await deleteAgent(ag.email); }
    catch (err) { setMsg({type:"err",text:err.message}); }
    setBusy(null);
  };

  const handleEditWallet = async (ag) => {
    const raw = window.prompt(`Set wallet amount for ${ag.name} (₹):`, String(ag.wallet_balance || 0));
    if (raw === null) return;
    const amount = Math.max(0, Number(raw) || 0);
    setBusy(ag.email);
    try { await setWallet(ag.email, amount); }
    catch (err) { setMsg({type:"err",text:err.message}); }
    setBusy(null);
  };

  const handleZeroWallet = async (ag) => {
    if (!window.confirm(`Reset ${ag.name}'s wallet to ₹0? Do this once their query/work is complete.`)) return;
    setBusy(ag.email);
    try { await zeroWallet(ag.email); }
    catch (err) { setMsg({type:"err",text:err.message}); }
    setBusy(null);
  };

  const iStyle = {width:"100%",padding:"11px 14px",border:"1.5px solid #dde3ed",borderRadius:9,fontSize:13,fontFamily:"'DM Sans',sans-serif",color:"#0d1f3c",background:"#fafbfd",outline:"none",boxSizing:"border-box"};
  const lbl = t => <label style={{display:"block",fontSize:11,fontWeight:600,letterSpacing:"1.5px",textTransform:"uppercase",color:"#5a6a80",marginBottom:6}}>{t}</label>;

  return (
    <AdminLayout navigate={navigate} active="agents" title="Agent Management">
      {/* ADD FORM */}
      <div style={{background:"#fff",borderRadius:16,border:"1px solid #e4e9f0",overflow:"hidden",marginBottom:24}}>
        <div style={{padding:"18px 24px",borderBottom:"1px solid #eaeef5",display:"flex",alignItems:"center",gap:12,background:"linear-gradient(135deg,#fafbfd,#fff)"}}>
          <div style={{width:38,height:38,borderRadius:10,background:"linear-gradient(135deg,#0d1f3c,#162844)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>➕</div>
          <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:20,fontWeight:600,color:"#0d1f3c"}}>Add New Agent</h2>
        </div>
        <div style={{padding:24}}>
          {msg && <div style={{background:msg.type==="ok"?"#dcfce7":"#fee2e2",border:`1px solid ${msg.type==="ok"?"#22c55e":"#ef4444"}`,color:msg.type==="ok"?"#166534":"#991b1b",padding:"12px 16px",borderRadius:10,fontSize:13,marginBottom:18}}>{msg.type==="ok"?"✅":"⚠"} {msg.text}</div>}
          <form onSubmit={submit}>
            <div className="rgrid-2" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
              <div>{lbl("Full Name *")}<input type="text"     value={form.name}     onChange={s("name")}     placeholder="Enter full name"     style={iStyle} required/></div>
              <div>{lbl("Email *")}    <input type="email"    value={form.email}    onChange={s("email")}    placeholder="agent@agency.com"       style={iStyle} required/></div>
              <div>{lbl("Agency *")}   <input type="text"     value={form.agency}   onChange={s("agency")}   placeholder="TravelPro India"        style={iStyle} required/></div>
              <div>{lbl("Password *")} <input type="password" value={form.password} onChange={s("password")} placeholder="Min 6 characters"      style={iStyle} required/></div>
              <div>{lbl("Role")}
                <select value={form.role} onChange={s("role")} style={iStyle}>
                  <option value="agent">Agent</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
            </div>
            <button type="submit" style={{padding:"11px 24px",background:"linear-gradient(135deg,#4a7fb5,#d4736a)",color:"#fff",border:"none",borderRadius:9,fontSize:13,fontWeight:600,cursor:"pointer"}}>➕ Add Agent</button>
          </form>
        </div>
      </div>

      {/* TABLE */}
      <div style={{background:"#fff",borderRadius:16,border:"1px solid #e4e9f0",overflow:"hidden"}}>
        <div style={{padding:"18px 24px",borderBottom:"1px solid #eaeef5",background:"linear-gradient(135deg,#fafbfd,#fff)"}}>
          <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:20,fontWeight:600,color:"#0d1f3c"}}>All Agents ({agents.length})</h2>
        </div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead style={{background:"#f6f8fc"}}>
              <tr>
                {["#","Name","Email","Agency","Role","Status","Wallet","KYC","Action"].map(h=>(
                  <th key={h} style={{padding:"12px 16px",textAlign:"left",fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"#8a9bb5",fontWeight:600,borderBottom:"1px solid #eaeef5"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {agents.map((ag,i)=>{
                const badge = STATUS_BADGE[ag.status] || STATUS_BADGE.active;
                const disabled = busy === ag.email;
                return (
                <tr key={ag.email} style={{borderBottom:"1px solid #f0f3f9",opacity:disabled?0.55:1}}>
                  <td style={{padding:"13px 16px",color:"#6b7a90",fontSize:13}}>{i+1}</td>
                  <td style={{padding:"13px 16px"}}><strong style={{fontSize:13}}>{ag.name}</strong></td>
                  <td style={{padding:"13px 16px",color:"#4a7fb5",fontSize:13}}>{ag.email}</td>
                  <td style={{padding:"13px 16px",fontSize:13}}>{ag.agency}</td>
                  <td style={{padding:"13px 16px"}}>
                    <span style={{fontSize:11,padding:"3px 10px",borderRadius:20,fontWeight:600,background:ag.role==="admin"?"#fef3e2":"#e0ecff",color:ag.role==="admin"?"#d97706":"#2563eb"}}>{ag.role}</span>
                  </td>
                  <td style={{padding:"13px 16px"}}>
                    <span style={{fontSize:11,padding:"3px 10px",borderRadius:20,fontWeight:600,background:badge.bg,color:badge.c}}>{badge.label}</span>
                  </td>
                  <td style={{padding:"13px 16px"}}>
                    {ag.role!=="admin" ? (
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <span style={{fontSize:13,fontWeight:700,color:"#0d1f3c"}}>{fmtWallet(ag.wallet_balance)}</span>
                        <button disabled={disabled} onClick={()=>handleEditWallet(ag)} title="Edit wallet amount" style={{padding:"3px 9px",borderRadius:7,fontSize:10,fontWeight:600,background:"#e0ecff",color:"#2563eb",border:"none",cursor:"pointer"}}>✏️</button>
                        {ag.wallet_balance > 0 && (
                          <button disabled={disabled} onClick={()=>handleZeroWallet(ag)} title="Reset to ₹0 (query complete)" style={{padding:"3px 9px",borderRadius:7,fontSize:10,fontWeight:600,background:"#fee2e2",color:"#dc2626",border:"none",cursor:"pointer"}}>↺ 0</button>
                        )}
                      </div>
                    ) : <span style={{fontSize:11,color:"#8a9bb5"}}>—</span>}
                  </td>
                  <td style={{padding:"13px 16px"}}>
                    {ag.pan_number || ag.aadhar_number ? (
                      <button onClick={()=>setKycAgent(ag)} style={{padding:"4px 11px",borderRadius:20,fontSize:11,fontWeight:600,background:"#dcfce7",color:"#16a34a",border:"none",cursor:"pointer"}}>✓ View KYC</button>
                    ) : (
                      <span style={{fontSize:11,color:"#8a9bb5"}}>— Not submitted</span>
                    )}
                  </td>
                  <td style={{padding:"13px 16px"}}>
                    {ag.role!=="admin" ? (
                      <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {ag.status!=="active" && (
                          <button disabled={disabled} onClick={()=>handleApprove(ag)} style={{padding:"5px 12px",borderRadius:7,fontSize:11,fontWeight:600,background:"#dcfce7",color:"#16a34a",border:"none",cursor:"pointer"}}>✓ Approve</button>
                        )}
                        {ag.status==="pending" && (
                          <button disabled={disabled} onClick={()=>handleReject(ag)} style={{padding:"5px 12px",borderRadius:7,fontSize:11,fontWeight:600,background:"#fef3e2",color:"#d97706",border:"none",cursor:"pointer"}}>✕ Reject</button>
                        )}
                        <button disabled={disabled} onClick={()=>handleDelete(ag)} style={{padding:"5px 12px",borderRadius:7,fontSize:11,fontWeight:600,background:"#fee2e2",color:"#dc2626",border:"none",cursor:"pointer"}}>🗑 Delete</button>
                      </div>
                    ) : (
                      <span style={{fontSize:11,color:"#8a9bb5"}}>Protected</span>
                    )}
                  </td>
                </tr>
              );})}
            </tbody>
          </table>
        </div>
      </div>

      {kycAgent && <KycModal agent={kycAgent} onClose={()=>setKycAgent(null)}/>}
    </AdminLayout>
  );
}
